<!--
 * @Author: QiTianDaSheng
 * @Date: 2023-07-17 16:13:15
 * @Descripttion: 
 * @LastEditors: QiTianDaSheng
 * @LastEditTime: 2023-08-10 15:19:24
-->
<!-- 行业解决方案 -->
<template>
    <div class="industrySolutionsBox">
        <div class="industrySolutions">
            <div class="title"></div>
            <div class="main">
                <div class="tabsBox">
                    <div :class="active == 1 ? 'tabsItem active' : 'tabsItem'" @mouseover="active = 1">
                        <i></i>
                        <strong>01</strong>
                        <h3>餐饮行业</h3>
                        <span></span>
                    </div>
                    <div :class="active == 2 ? 'tabsItem active' : 'tabsItem'" @mouseover="active = 2">
                        <i></i>
                        <strong>02</strong>
                        <h3>制造行业</h3>
                        <span></span>
                    </div>
                    <div :class="active == 3 ? 'tabsItem active' : 'tabsItem'" @mouseover="active = 3">
                        <i></i>
                        <strong>03</strong>
                        <h3>保险行业</h3>
                        <span></span>
                    </div>
                    <div :class="active == 4 ? 'tabsItem active' : 'tabsItem'" @mouseover="active = 4">
                        <i></i>
                        <strong>04</strong>
                        <h3>仓储物流行业</h3>
                        <span></span>
                    </div>
                </div>
                <div class="detailedInfo">
                    <div class="detailedInfoItem" v-show="active == 1">
                        <div class="infoTitle">
                            <h3>餐饮行业</h3>
                        </div>
                        <div class="infoBox">
                            <div class="infoitem">
                                <div class="txt">
                                    1.简化结账流程：直接与餐饮POS系统或支付平台对接，实现一键开票和结账流程自动化。消费者无需等待手动打印纸质发票，节省了时间，同时也减少了人为失误的可能性。
                                </div>
                            </div>
                            <div class="infoitem">
                                <div class="txt">2.方便管理和整理：电子发票通过数字化形式存储，实现自动化管理和快速检索。</div>
                            </div>
                            <div class="infoitem">
                                <div class="txt">
                                    3.提升用户体验：聚合支付提供了多种支付方式(如支付宝、微信、银行卡等)的选择，方便消费者根据个人喜好进行支付。消费者可以使用手机或其他电子设备进行扫码支付，无需携带现金或银行卡，提升了支付的便捷性和效率，增强了消费者的体验感。
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="detailedInfoItem" v-show="active == 2">
                        <div class="infoTitle">
                            <h3>制造行业</h3>
                        </div>
                        <div class="infoBox">
                            <div class="infoitem">
                                <div class="txt">
                                    1.将现有的工厂管理业务搬到线上，结合原有专业业务系统，通过数据整合，业务整合和管理创新，打造工厂数字化管理智能协同平台。
                                </div>
                            </div>
                            <div class="infoitem">
                                <div class="txt">2.智能数字办公，效率提升60%；智能预警提醒，准确效率提升80%。</div>
                            </div>
                            <div class="infoitem">
                                <div class="txt">3.生命周期管理；实时跟踪预警。</div>
                            </div>
                            <div class="infoitem">
                                <div class="txt">4.优化管理模式，实现智协同。</div>
                            </div>
                            <div class="infoitem">
                                <div class="txt">5.智能数字管理，助力优化生产。</div>
                            </div>
                        </div>
                    </div>
                    <div class="detailedInfoItem" v-show="active == 3">
                        <div class="infoTitle">
                            <h3>保险行业</h3>
                        </div>
                        <div class="infoBox">
                            <div class="infoitem">
                                <div class="txt">1.通过协同办公系统解决跨部门协作沟通成本高、协同难度大等问题。</div>
                            </div>
                            <div class="infoitem">
                                <div class="txt">2.提高日常工作推动效率及内部汇报反馈时效。</div>
                            </div>
                            <div class="infoitem">
                                <div class="txt">3.避免了任务下达后，层级多、人员广、落实情况难追踪的状况，实现沟通、培训、协同零距离。</div>
                            </div>
                        </div>
                    </div>
                    <div class="detailedInfoItem" v-show="active == 4">
                        <div class="infoTitle">
                            <h3>仓储物流行业</h3>
                        </div>
                        <div class="infoBox">
                            <div class="infoitem">
                                <div class="txt">1.大大的克服了物流仓储行业员工多且分散，用工形式多样、工时制度多样，集中统一化管理难度大的行业困境。</div>
                            </div>
                            <div class="infoitem">
                                <div class="txt">
                                    2.为企业提供更加有效匹配实际业务需求的资源优化配置建议，更加有效的统计维度和指标辅助决策，帮助企业科学合理用工，控制人力成本，实现精细化管理。
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
  data() {
    return {
      active: 1,
    }
  },
  components: {},
  mounted() {},
  methods: {},
}
</script>
<style scoped lang="scss">
.industrySolutionsBox {
  margin-top: 70px;

  width: 100%;
  height: 752px;
  background: url('../../../assets/image/home/industrySolutions_bg01.png') no-repeat;
  background-position: center center;
  background-size: 100% 100%;
  position: relative;

  &::before {
    content: '';
    width: 552px;
    height: 699px;
    position: absolute;
    bottom: 0;
    right: 0;
    background: url('@/assets/image/home/industrySolutions_bg03.png') no-repeat;
    background-size: 100% 100%;
    z-index: 0;
  }

  .industrySolutions {
    width: 1200px;
    margin: 0 auto;
    padding-top: 50px;
    box-sizing: border-box;
    position: relative;

    &::before {
      content: '';
      width: 983px;
      height: 585px;
      position: absolute;
      top: 104px;
      right: -92px;
      background: url('@/assets/image/home/industrySolutions_bg02.png') no-repeat;
      background-size: 100% 100%;
      z-index: 0;
    }

    .title {
      width: 434px;
      height: 89px;
      margin: 0 auto;
      background: url('../../../assets/image/home/industrySolutionsTitle.png') no-repeat;
      background-position: top center;
    }

    .main {
      display: flex;

      width: 1197px;
      height: 470px;
      margin: 56px auto 0;
      background: rgba(255, 255, 255, 0.7);

      position: absolute;
      z-index: 3;

      .tabsBox {
        flex: 0 0 295px;
        width: 295px;
        height: 470px;
        padding-top: 35px;
        box-sizing: border-box;

        .tabsItem {
          width: 100%;
          height: 100px;
          padding-right: 16px;
          box-sizing: border-box;
          cursor: pointer;
          background-color: #fff;

          display: flex;
          align-items: center;

          i {
            width: 8px;
            height: 100px;
          }

          strong {
            margin: 0 17px 0 19px;
            height: 48px;
            font-size: 34px;
            font-family: Alibaba PuHuiTi 2-95 ExtraBold, Alibaba PuHuiTi 20;
            font-weight: 800;
            color: #aaaaaa;
            line-height: 48px;
          }

          h3 {
            height: 34px;
            font-size: 24px;
            font-family: Alibaba PuHuiTi 2-85 Bold, Alibaba PuHuiTi 20;
            font-weight: 500;
            color: #1a1a1a;
            line-height: 34px;
          }

          span {
            margin-left: auto;
            width: 42px;
            height: 42px;
            background: url('../../../assets/image/home/industrySolutions_tabsIcon.png') no-repeat;
            background-position: center center;
          }
        }

        .active {
          background: linear-gradient(270deg, #f0f4f9 6%, #f6f7fc 97%);

          i {
            background-color: #be1a21;
          }

          strong,
          h3 {
            color: #1a1a1a;
          }

          span {
            background: url('../../../assets/image/home/industrySolutions_tabsIconBg.png') no-repeat;
          }
        }
      }

      .detailedInfo {
        .detailedInfoItem {
          margin: 54px 56px 0 59px;
          text-align: left;

          .infoTitle {
            h3 {
              font-size: 28px;
              font-family: Alibaba PuHuiTi 2-85 Bold, Alibaba PuHuiTi 20;
              font-weight: 700;
              color: #1a1a1a;
              line-height: 39px;
            }

            p {
              margin-top: -3px;
              font-size: 14px;
              font-family: Alibaba PuHuiTi 2-55 Regular, Alibaba PuHuiTi 20;
              font-weight: 400;
              color: #767676;
              line-height: 20px;
            }
          }

          .infoBox {
            margin-top: 34px;

            .infoitem {
              margin-bottom: 11px;

              .txt {
                margin-bottom: 18px;
                font-size: 14px;
                font-family: Alibaba PuHuiTi 2-55 Regular, Alibaba PuHuiTi 20;
                font-weight: 400;
                color: #767676;
                line-height: 28px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
